import { render, staticRenderFns } from "./LoadValuesModal.vue?vue&type=template&id=23ddaefa&"
import script from "./LoadValuesModal.vue?vue&type=script&lang=js&"
export * from "./LoadValuesModal.vue?vue&type=script&lang=js&"
import style0 from "./LoadValuesModal.vue?vue&type=style&index=0&id=23ddaefa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports